import React, { Component } from 'react';
import { Button, Sidebar, Menu, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export class MobileMenu extends Component {
  state = { visible: false }

  toggleSidebar = () => {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  }

  hideSideBar = () => {
    this.setState({ visible: false });
  }

  render() {
    const { visible } = this.state;
    const { menuItems } = this.props;
    return (
      <div className="Header__TitleBar__Menu--Mobile">
        <Button
          disabled={visible}
          compact
          content="Menu"
          icon={visible ? 'close' : 'bars'}
          labelPosition="left"
          onClick={() => {
            this.toggleSidebar();
          }}
          className="Header__TitleBar__Menu--Mobile__Buttons"
        />
        <Sidebar
          as={Menu}
          animation="push"
          icon="labeled"
          direction="left"
          inverted
          onClick={this.toggleSidebar}
          onHide={this.hideSideBar}
          vertical
          visible={visible}
          width="thin"
        >
          {menuItems.map(({ name, link, icon }) => (
            <Link to={link} key={name}>
              <Menu.Item as="p">
                <Icon name={icon} />
                {name}
              </Menu.Item>
            </Link>
          ))}
        </Sidebar>
      </div>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/Header/Menu/MobileMenu.js